import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Coins, Loader2 } from 'lucide-react';
import api from '../../../services/api';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../ui/card';
import { Button } from '../../ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';
import { setCurrency } from '../../../lib/currency';

// Tenant currency: what this academy charges parents in (Stripe + invoices).
export const CurrencyCard = () => {
  const [data, setData] = useState(null);
  const [value, setValue] = useState('usd');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get('/admin/payment-settings/currency')
      .then((r) => { setData(r.data); setValue(r.data.currency); })
      .catch(() => toast.error('Could not load currency'));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put('/admin/payment-settings/currency', { currency: value });
      setCurrency(value);
      setData((d) => ({ ...d, currency: value }));
      toast.success('Currency saved — new invoices and charges will use it');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Could not save currency');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card data-testid="currency-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2"><Coins className="h-5 w-5" />Currency</CardTitle>
        <CardDescription>
          The currency parents are invoiced and charged in. Existing invoices keep their original currency.
          Bank transfer (ACH) is only available in US Dollars.
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-wrap items-center gap-3">
        <Select value={value} onValueChange={setValue} disabled={!data}>
          <SelectTrigger className="w-72" data-testid="currency-select"><SelectValue /></SelectTrigger>
          <SelectContent>
            {(data?.options || []).map((o) => (
              <SelectItem key={o.code} value={o.code} data-testid={`currency-option-${o.code}`}>
                {o.symbol} · {o.code.toUpperCase()} — {o.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <Button onClick={save} disabled={!data || saving || value === data?.currency} data-testid="currency-save-btn">
          {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Save currency
        </Button>
      </CardContent>
    </Card>
  );
};
